export const SMARTLI_APPSTORE_URL =
  "https://apps.shopify.com/smartli-ai-product-description?utm_source=stylesi&utm_medium=app&utm_campaign=ask-ai";

export const SPOCKET_APP_ASSETS_BUCKET_URL =
  "https://d3eyb8shadqthh.cloudfront.net";
